<template>
  <div>
    <v-row
      no-gutters
      align=center
      justify=space-between
      v-if="teacher"
      class="main--text"
      >
      <v-col
        cols=12
        md=8
        sm=7>
        <v-container
          fluid>
          <v-row
            no-gutters
            align=center
            justify=center
            justify-sm=start
            justify-md=start
            >
            <v-col
              cols=auto>
              <v-avatar
                size="60">
                <img :src="teacher.iconUrl" alt="">
              </v-avatar>
            </v-col>
            <v-col
              cols=auto>
              <v-container
                fluid>
                <v-row
                  no-gutters>
                  <v-col
                    class="subheading">
                    {{ lesson.schedule.toString() }}
                  </v-col>
                </v-row>
                <v-row
                  no-gutters>
                  <v-col>
                    <span class="teacher--name">{{ teacher.fullName() }}</span> 先生
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col
        cols=12
        md=4
        sm=5
        >
        <v-container
          fluid>
          <v-row
            dense
            align=center
            justify=center
            justify-md=end
            justify-sm=end>
            <v-col
              cols=auto>
              <v-btn
                rounded
                depressed
                outlined
                color="primary"
                @click="record">
                授業結果を入力
              </v-btn>
            </v-col>
            <v-col
              cols=auto>
              <v-tooltip
                top>
                <template v-slot:activator="{on}">
                  <v-icon
                    small
                    v-on="on"
                    color="grey lighten-2"
                    @click="confirmDelete=true"
                    >mdi-close-circle</v-icon>
                </template>
                スケジュールを削除する
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col
        cols=auto>
      </v-col>
    </v-row>
    <v-dialog
      :value="confirmDelete"
      width=300>
      <v-card>
        <v-container>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              担当の先生と合意できていますか？
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              本当に削除してよろしいですか？
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                rounded
                outlined
                depressed
                @click="closeConfirm">閉じる</v-btn>
            </v-col>
            <v-col
              cols=auto>
              <v-btn
                rounded
                outlined
                depressed
                color="grey"
                @click="deleteSchedule">削除</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    lesson: Object,
    teacher: Object
  },
  data () {
    return {
      confirmDelete: false
    }
  },
  methods: {
    record() {
      this.$emit("input-button-click", this.lesson, this.teacher)
    },
    deleteSchedule() {
      this.confirmDelete = false
      this.$emit('delete-button-click', this.lesson.id)
    },
    closeConfirm() {
      this.confirmDelete = false
    }
  }
}
</script>

<style>
.teacher--name {
  font-size: 1.4rem
}
</style>
